import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NameValue, ModalResult, ModalAnswer } from '../../../shared/models/shared.model';
import { Meeting, SelectableDealer, Dealer } from '../../model/distributor.model';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { assign } from 'rxjs/util/assign';
import { now } from 'moment';
import { AdaService } from '../../../shared/services/ada.service';

@Component({
  selector: 'app-opportunity-meeting',
  templateUrl: './opportunity-meeting.component.html',
  styleUrls: ['./opportunity-meeting.component.scss']
})
export class OpportunityMeetingComponent implements OnInit {

  @Input() visible = false;
  @Input() states: Array<NameValue> = [];
  @Input() dealers: Array<Dealer> = [];
  // @Input() invitees: Array<Dealer> = [];
  @Input() selectedDealers: Array<Dealer> = [];

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onModalClose: EventEmitter<ModalResult> = new EventEmitter<ModalResult>();

  inviteDealersPopupVisible = false;
  minDate: Date;

  submitted = false;
  form: FormGroup;
  meeting = new Meeting({
    name: '', // 'New Meeting Location',
    addressLine1: '', // '12 Main Street',
    city: '', // 'Atlanta',
    state: '', // 'GA',
    zip: '', // '30318',
    requestedDate: new Date(),
    comments: '', // 'Some Comments',
    invitees: new Array<Dealer>()
  });

  errorMessages = {
    'name.required': 'Meeting name is required',
    'addressLine1.required': 'Address is required',
    'city.required': 'City is required',
    'state.required': 'State is required',
    'zip.required': 'Zip is required',
    'requestedDate.required': 'Requested Date is required',
    'comments.required': 'Comments are required',
  };
  errors = [];

  constructor(private fb: FormBuilder, private _adaService: AdaService) { }

  ngOnInit() {
    this.minDate = new Date(now() + (1000 * 60 * 60 * 24 * 14)); // 14 days
    this.createForm();
    this.form.patchValue(this.meeting);
  }

  get adaService() {
    return this._adaService;
  }

  createForm() {
    this.form = this.fb.group(
      {
        name: ['', Validators.required],
        addressLine1: ['', Validators.required],
        city: ['', Validators.required],
        state: ['', Validators.required],
        zip: ['', Validators.required],
        requestedDate: ['', Validators.required],
        foodProvided: [''],
        comments: ['', Validators.required]
      });
  }

  get formControls() {
    return this.form.controls;
  }

  onCancel() {
    this.form.reset(this.meeting);
    this.onModalClose.emit({ answer: ModalAnswer.CANCEL, data: this.meeting });
  }

  whenPopupHidden(e) {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onSubmit() {
    this.prepareValidationSummary();
    this.submitted = true;
    if (this.form.valid) {
      const tempInvites = this.meeting.invitees;
      this.meeting = this.form.value;
      this.meeting.invitees = tempInvites;
      this.onModalClose.emit({answer: ModalAnswer.OK, data: this.meeting});
      console.table(this.form.value);
    }
  }

  prepareValidationSummary() {
    this.errors.length = 0;
    for (const field in this.form.controls) { // 'field' is a string
      const control = this.form.get(field); // 'control' is a FormControl
      if (control.errors) {
        for (const error in control.errors) {
          const key = field + '.' + error;
          const x = this.errorMessages[key];
          this.errors.push(x);
        }
      }
    }
    console.table(this.errors);
  }

  addSponsoredDealer() {
    this.inviteDealersPopupVisible = true;
  }

  addNewDealer() {
    alert('add new dealer');
  }

  whenSelectDealerClose(modalResult: ModalResult) {
    if (modalResult.answer == ModalAnswer.OK) {
      this.selectedDealers = modalResult.data;
      this.addSelectedDealersToInvitees();
    }
    this.inviteDealersPopupVisible = false;
  }

  private addSelectedDealersToInvitees() {
    this.selectedDealers.forEach((dealer => {
         if(!this.meeting.invitees.find(inv => inv.id == dealer.id)) {
           this.meeting.invitees.push(dealer);
         }
      }
    ));
  }
}



// WEBPACK FOOTER //
// ./src/app/distributor/components/opportunity-meeting/opportunity-meeting.component.ts